import { normalizeLocale } from 'src/i18n/config'

const DEFAULT_LOCALE = 'pl'

const PARAM_NAMES = {
  pl: {
    page: 'strona',
    sort: 'sortowanie',
    tab: 'zakladka',
    field: 'dziedzina',
    discipline: 'dyscyplina',
  },
  en: {
    page: 'page',
    sort: 'sort',
    tab: 'tab',
    field: 'field',
    discipline: 'discipline',
  },
}

const PARAM_VALUE_TRANSLATIONS = {
  sort: [
    { pl: 'najnowsze', en: 'newest' },
    { pl: 'najstarsze', en: 'oldest' },
    { pl: 'domyslne', en: 'default' },
  ],
  tab: [
    { pl: 'biezace', en: 'latest' },
    { pl: 'archiwalne', en: 'archived' },
    { pl: 'wszystko', en: 'all' },
    { pl: 'czasopisma', en: 'journals' },
    { pl: 'numery', en: 'issues' },
    { pl: 'artykuly', en: 'articles' },
    { pl: 'ksiazki', en: 'books' },
    { pl: 'rozdzialy', en: 'chapters' },
  ],
}

export const getListQueryLocale = (locale) => {
  const normalizedLocale = normalizeLocale(locale)

  if (!normalizedLocale) return DEFAULT_LOCALE

  return normalizedLocale === 'pl' ? 'pl' : 'en'
}

export const getListQueryParamName = (type, locale) => {
  return PARAM_NAMES[getListQueryLocale(locale)]?.[type] || null
}

const getParamType = (name) =>
  Object.values(PARAM_NAMES)
    .flatMap((paramNames) => Object.entries(paramNames))
    .find(([, paramName]) => paramName === name)?.[0] || null

export const translateListQueryParamValue = (type, value, targetLocale) => {
  const translation = PARAM_VALUE_TRANSLATIONS[type]?.find((values) => Object.values(values).includes(value))

  return translation?.[getListQueryLocale(targetLocale)] || value
}

/**
 * Wartość parametru stanu listy z adresu: najpierw pod nazwą w języku strony, potem w pozostałych,
 * żeby starsze linki (np. `?field=16` na polskiej stronie) dalej działały.
 */
export const getListQueryParamValue = (searchParams, type, locale) => {
  const names = [
    getListQueryParamName(type, locale),
    ...Object.values(PARAM_NAMES).map((paramNames) => paramNames[type]),
  ]
  const name = names.find(
    (paramName) => paramName && searchParams?.[paramName] !== undefined && searchParams?.[paramName] !== null,
  )

  return name ? searchParams[name] : undefined
}

// Numer strony z adresu (`strona` albo `page`); brak lub niepoprawna wartość to pierwsza strona.
export const readListQueryPage = (searchParams, locale) => {
  const value = getListQueryParamValue(searchParams, 'page', locale)
  const page = Number.parseInt(String((Array.isArray(value) ? value[0] : value) ?? ''), 10)

  return Number.isSafeInteger(page) && page > 0 ? page : 1
}

export const localizeListQueryParam = (name, value, targetLocale) => {
  const type = getParamType(name)

  if (!type) return { name, value }

  return {
    name: getListQueryParamName(type, targetLocale),
    value: translateListQueryParamValue(type, value, targetLocale),
  }
}
